import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Link, useLocation } from 'react-router-dom';
import { Paper, Grid } from '@material-ui/core';
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import Moment from "moment";
import BiztranControls from "../../components/biztran_controls/BiztranControls";
// import ModelFrame from "../../components/biztran_controls/Modal_Frame";
import UseFetchData from "../../hooks/UseFetchData";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
//import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { TreeView, TreeItem } from '@material-ui/lab';
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";


const todate = new Date();
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);


const StockLedger = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [Count, setCount] = useState('');
  const [DocumentTypecmb, setDocumentTypecmb] = useState([]);
  const [TransactionStoreID, setTransactionStoreID] = useState('');
  const [TransactionStorecmb, setTransactionStorecmb] = useState([]);
  const [FromDate, setFromDate] = useState(fromdate.toISOString());
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [responseTransactionStore, fetchTransactionStoreData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [responseTotal, fetchTotalData] = UseFetchData([]);
  const [InventoryDocumentID, setInventoryDocumentID] = useState('')
  const [DocumentNo, setDocumentNo] = useState('');
  const [AccountID, setAccountID] = useState('');
  const [AccName, setAccName] = useState('');
  const [OpBal, setOpBal] = useState("");
  const [InQty, setInQty] = useState('');
  const [OutQty, setOutQty] = useState('');
  const [ClBal, setClBal] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [AccountOptions, setAccountOptions] = useState([]);
  const [responseProduct, fetchProductData] = UseFetchData();
  const [ProductGroupcmb, setProductGroupcmb] = useState([]);
  const [ProductGroupID, setProductGroupID] = useState('');
  const [ProductSkuId, setProductSkuId] = useState('');
  const [Productcmb, setProductcmb] = useState([]);
  const [ProductID, setProductID] = useState('');
  const [treeData, setTreeData] = useState([]);


  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const handleOpenModal = () => {
    setOpen(true);
    setInventoryDocumentID('');
  }

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children) ? nodes.children.map((node) => (
        <TreeItem
          key={node.id}
          nodeId={node.id.toString()}
          label={node.name}
          onClick={() => handleChildItemClick(node.id)}
        />
      ))
        : null}
    </TreeItem>
    //renderTree(node)) : null}
  );

  const handleChildItemClick = (childItemId) => {
    console.log('Clicked child item:', childItemId);
    setProductSkuId(childItemId);
    PopulateData();
  };

  const convertToTreeStructure = (data) => {
    // Recursive function to convert the API response to a nested tree structure
    // const map = new Map();
    // const roots = [];

    // data.forEach((node) => {
    //   node.children = [];
    //   map.set(node.id, node);

    //   if (!node.parentId) {
    //     roots.push(node);
    //   } else {
    //     const parent = map.get(node.parentId);
    //     if (parent) {
    //       parent.children.push(node);
    //     }
    //   }
    // });

    // return roots;

    const tree = {};

    data.forEach((item) => {
      const { product_id, product_name, sku_id, model_code } = item;

      if (!tree[product_id]) {
        tree[product_id] = {
          id: product_id,
          name: product_name,
          children: [],
        };
      }

      tree[product_id].children.push({
        id: sku_id,
        name: model_code,
      });
    });

    return Object.values(tree);
  };


  const PopulateData = () => {
    debugger;
    var PGID = "";
    var AccoName = "";
    var bodyFormData = new FormData();
    if (AccountName !== undefined) {
      AccoName = AccountName.List;
    }
    if (ProductGroupID !== "") {
      PGID = ProductGroupID;
    }

    var bodyFormData = new FormData();
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));;
    bodyFormData.append("ProductGroupID", ProductGroupID);
    bodyFormData.append("TransactionStoreID", TransactionStoreID);
    bodyFormData.append("ProductSkuId", ProductSkuId);
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("AccountName", AccoName);
    fetchData("StockLedger/StockLedgerList", bodyFormData);
    fetchTotalData("StockLedger/StockTotal", bodyFormData);
  };

  const GetComboData = () => {
    var bodyFormData = new FormData();
    fetchTransactionStoreData("StockLedger/ComboData", bodyFormData);
  };

  useEffect(() => {
    if (responseTotal !== undefined && responseTotal.length > 0) {
      debugger;
      console.log(responseTotal[0].OpBal);
      setOpBal(responseTotal[0].OpBal);
      setInQty(responseTotal[0].toinqty);
      setOutQty(responseTotal[0].tooutqty);
      setClBal(responseTotal[0].clbal);
      //if (responseTotal[0]["OpBal"] !== undefined) {

      //console.log(responseTotal[0]["clbal"]);
      // if (responseTotal[0]["opbal"] !== undefined) {
      //setOpBal(responseTotal[0]["clbal"]);
      //}
      // }
    }
  }, [responseTotal]);



  useEffect(() => {
    if (responseTransactionStore !== undefined) {
      // debugger;
      if (responseTransactionStore["cmbStore"] !== undefined) {
        setTransactionStorecmb(responseTransactionStore["cmbStore"]);
      }
      else {
        setTransactionStorecmb([]);
      }
      if (responseTransactionStore['cmbAccount'] !== undefined) {
        setAccountOptions(responseTransactionStore['cmbAccount']);
      }
      else {
        setAccountOptions([]);
      }
      if (responseTransactionStore['cmbProductGroup'] !== undefined) {
        setProductGroupcmb(responseTransactionStore['cmbProductGroup']);
      }
      else {
        setProductGroupcmb([]);
      }
      if (responseTransactionStore['Productcmb'] !== undefined) {
        setProductcmb(responseTransactionStore['Productcmb']);
      }
      else {
        setProductcmb([]);
      }
      if (responseTransactionStore['ProductTreeView'] !== undefined) {
        const modifiedTreeData = convertToTreeStructure(responseTransactionStore['ProductTreeView']);
        setTreeData(modifiedTreeData);
        debugger;
      }

    }
  }, [responseTransactionStore]);


  useEffect(() => {
    PopulateData();
    GetComboData();
  }, [])

  const onACCChange = (event, newValue) => {
    // debugger;
    setAccountName(newValue);
    setAccountID(newValue.id);
  }

  useEffect(() => {
    const gridCols = [
      // {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) => (<strong> <Link to={{ pathname: "/StockLedger/StockLedgerView", state: { InventoryDocumentID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
      //   //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 70,
      // },
      {
        field: "DocumentDate",
        headerName: "Document Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 190,
        valueFormatter: params =>
          moment(params?.value).format("DD/MM/YYYY"),
      },
      {
        field: "DocumentType",
        headerName: "Document Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ModelCode",
        headerName: "Model Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ProductName",
        headerName: "Product Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "StoreName",
        headerName: "Store",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
        // renderCell: (params) => (
        //   <Tooltip title={params.row.DocumentType} >
        //     <span className="table-cell-trucate">{params.row.DocumentType}</span>
        //   </Tooltip>
        // )
      },
      {
        field: "InQty",
        headerName: "InQty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "OutQty",
        headerName: "OutQty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]);



  useEffect(() => {
    PopulateData();
  }, [])

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport csvOptions={{
          fields: ['DocumentDate', 'DocumentType', 'ModelCode', 'ProductName', 'StoreName', 'InQty', 'OutQty']
        }} />
      </GridToolbarContainer>
    );
  }

  return (
    <div >
      <Grid container direction="row" style={{ marginTop: -10 }} >
        <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
          <div style={{ width: "200px", marginLeft: 17 }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            />
          </div>
        </Grid>
        <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
          <div style={{ width: "200px", marginLeft: 5 }}>
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            />
          </div>
        </Grid>

      </Grid>
      <Grid container direction="row" style={{ marginTop: 20 }}>
        {/* <BiztranControls.Autocomplete
          label="Account Name"
          style={{ marginLeft: 8, width: "250px" }}
          options={AccountOptions}
          onChange={onACCChange}
          value={AccName}>
        </BiztranControls.Autocomplete> */}
        <BiztranControls.Select
          label="Transaction Store"
          id="TransactionStore"
          style={{ width: "200px", marginLeft: 10, marginTop: -10, marginRight: 10 }}
          options={TransactionStorecmb}
          onChange={(e) => setTransactionStoreID(e.target.value)}
        />
        <BiztranControls.Select
          label="ProductGroup"
          id="ProductGroup"
          style={{ width: 'maxWidth', marginTop: -8 }}
          options={ProductGroupcmb}
          onChange={(e) => setProductGroupID(e.target.value)}
        />
        {/* <BiztranControls.Select
          label="Product"
          id="Product"
          style={{ width: 'maxWidth', marginTop: -8 }}
          options={Productcmb}
          onChange={(e) => setProductID(e.target.value)}
        /> */}
        <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: 7 }}>{Count}</label>
        <BiztranControls.Button
          responsive="true"
          text="Populate"
          startIcon={<SearchIcon />}
          onClick={() => {
            PopulateData();
          }}
        />

        <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
          {renderTree(treeData)}
        </TreeView>


      </Grid>
      <Grid container direction="row">
        <TreeView
          aria-label="rich object"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpanded={['root']}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ height: 110, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
        >
          {treeData.map((node) => renderTree(node))}
        </TreeView>

        <BiztranControls.DataGrid
          headerHeight={34}
          rowHeight={25}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          Height="auto"
          //Height="110"
          Width="70%"
          components={{ Toolbar: CustomToolbar, }}
        />
        <label style={{ marginLeft: 250, marginTop: 15, fontSize: 16 }}>Op.Bal</label>
        <BiztranControls.Input
          //label="Doc Number"
          value={OpBal}
          id="DocNumber"
          style={{ width: "150px", marginLeft: 30 }}
        //onChange={(e) => setDocumentNo(e.target.value)}
        />
        <label style={{ marginLeft: 20, marginTop: 15, fontSize: 16 }}>InQty</label>
        <BiztranControls.Input
          //label="Doc Number"
          value={InQty}
          id="DocNumber"
          style={{ width: "150px", marginLeft: 30 }}
        //onChange={(e) => setDocumentNo(e.target.value)}
        />

        <label style={{ marginLeft: 20, marginTop: 15, fontSize: 16 }}>OutQty</label>
        <BiztranControls.Input
          //label="Doc Number"
          value={OutQty}
          id="DocNumber"
          style={{ width: "150px", marginLeft: 30 }}
        //onChange={(e) => setDocumentNo(e.target.value)}
        />

        <label style={{ marginLeft: 20, marginTop: 15, fontSize: 16 }}>Cl.Bal</label>
        <BiztranControls.Input
          //label="Doc Number"
          value={ClBal}
          id="DocNumber"
          style={{ width: "150px", marginLeft: 30 }}
        //onChange={(e) => setDocumentNo(e.target.value)}
        />

      </Grid>
      <Grid item xs={12} sm={3} md={2} lg={2.5} xl={1.5} >

      </Grid>
    </div >
  );
};

export default StockLedger;
